export enum messagesStatus {
    login =   "Welcome Back",
    success = "created successfully",
    update = "updated successfully",
    delete = "deleted successfully",
    sendNotification = "Notification sent successfully",
  }
